import { render } from "./NavBarBigScreen.vue?vue&type=template&id=23f35554"
import script from "./NavBarBigScreen.vue?vue&type=script&lang=js"
export * from "./NavBarBigScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__